import React, { useState } from 'react'
import Modal from 'react-modal'
import Button from '../../components/CustomButton'
import { ModalHeading, ModalButtons, StyledCheckbox } from './style'

const customStyles = {
    content: {
        maxWidth: '90%', // Ancho máximo del 90% del contenedor
        width: '600px',
        margin: 'auto',
        padding: '40px 30px',
        border: '0',
        borderRadius: '20px',
        backgroundColor: '#fff',
        overflow: 'auto',
        minHeight: '440px',
        position: 'relative',
        left: '0',
        right: '0',
        top: '20%',
        bottom: '0'
    },
    overlay: { backgroundColor: 'rgba(36, 35, 49, 0.80)', zIndex: '999' }
}
Modal.setAppElement('#root')
const ModalCookies = ({ isOpen, onClose, setShowBanner }) => {
    const initialCookieSettings = JSON.parse(localStorage.getItem('cookiePreferences')) || {
        cookie1: false,
        cookie2: false,
        cookie3: false
    }
    const [cookieSettings, setCookieSettings] = useState(initialCookieSettings)
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target
        setCookieSettings((prevSettings) => ({
            ...prevSettings,
            [name]: checked
        }))
    }

    const saveCookieSettings = () => {
        localStorage.setItem('cookiePreferences', JSON.stringify(cookieSettings))
        onClose()
        setShowBanner(false)
    }
    const closeModal = () => {
        onClose()
    }
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}
            contentLabel="Configuración avanzada de cookies"
        >
            <ModalHeading>Configuración avanzada de cookies</ModalHeading>
            <StyledCheckbox>
                <input
                    type="checkbox"
                    name="cookie1"
                    id="cookie1"
                    checked={cookieSettings.cookie1}
                    onChange={handleCheckboxChange}
                />
                <label htmlFor="cookie1">Cookies esenciales</label>
                <p>
                    Estas cookies permiten funciones básicas como la seguridad, la verificación de
                    la identidad y la administración de la red. Estas cookies no pueden ser
                    desactivadas.
                </p>
            </StyledCheckbox>
            <StyledCheckbox>
                <input
                    type="checkbox"
                    name="cookie2"
                    id="cookie2"
                    checked={cookieSettings.cookie2}
                    onChange={handleCheckboxChange}
                />
                <label htmlFor="cookie2">Cookies funcionales</label>
                <p>
                    Estas cookies recopilan datos para recordar las elecciones que los usuarios
                    hacen, para mejorar y ofrecer una experiencia más personalizada.
                </p>
            </StyledCheckbox>
            <StyledCheckbox>
                <input
                    type="checkbox"
                    name="cookie3"
                    id="cookie3"
                    checked={cookieSettings.cookie3}
                    onChange={handleCheckboxChange}
                />
                <label htmlFor="cookie3">Cookies de analíticas</label>
                <p>
                    Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestra
                    página web, descubren errores y proporcionan mejores analíticas generales.
                </p>
            </StyledCheckbox>
            <ModalButtons>
                <Button
                    type="button"
                    onClick={saveCookieSettings}
                    buttonType="primary"
                    size="lg"
                    category="default"
                    fontSize="10px"
                    textAlign="center"
                >
                    Aceptar
                </Button>
                <Button
                    type="button"
                    onClick={closeModal}
                    buttonType="tertiary"
                    size="lg"
                    category="default"
                    fontSize="10px"
                    textAlign="center"
                >
                    Cancelar
                </Button>
            </ModalButtons>
        </Modal>
    )
}

export default ModalCookies
